var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 4.5C3.5 3.67157 4.17157 3 5 3H20C20.8284 3 21.5 3.67157 21.5 4.5V19.5C21.5 20.3284 20.8284 21 20 21H5C4.17157 21 3.5 20.3284 3.5 19.5V4.5ZM20 4.5H5V19.5H20V4.5Z",
    fill: "#4C576C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 1.5C17.4142 1.5 17.75 1.83579 17.75 2.25V5.25C17.75 5.66421 17.4142 6 17 6C16.5858 6 16.25 5.66421 16.25 5.25V2.25C16.25 1.83579 16.5858 1.5 17 1.5Z",
    fill: "#4C576C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5C8.41421 1.5 8.75 1.83579 8.75 2.25V5.25C8.75 5.66421 8.41421 6 8 6C7.58579 6 7.25 5.66421 7.25 5.25V2.25C7.25 1.83579 7.58579 1.5 8 1.5Z",
    fill: "#4C576C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 8.25C3.5 7.83579 3.83579 7.5 4.25 7.5H20.75C21.1642 7.5 21.5 7.83579 21.5 8.25C21.5 8.66421 21.1642 9 20.75 9H4.25C3.83579 9 3.5 8.66421 3.5 8.25Z",
    fill: "#4C576C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.375 12C8.375 11.5858 8.71079 11.25 9.125 11.25H11.75C12.0383 11.25 12.3011 11.4153 12.426 11.6751C12.5509 11.935 12.5158 12.2434 12.3357 12.4685L11.5055 13.5062C11.7487 13.6692 11.9584 13.8786 12.1221 14.1231C12.3282 14.4308 12.4551 14.7846 12.4916 15.1531C12.5281 15.5216 12.4731 15.8934 12.3315 16.2355C12.1899 16.5777 11.966 16.8796 11.6798 17.1144C11.3935 17.3493 11.0537 17.5099 10.6905 17.582C10.3273 17.654 9.95187 17.6354 9.59761 17.5276C9.24335 17.4198 8.92117 17.2262 8.65965 16.9641C8.36712 16.6708 8.36769 16.1959 8.66094 15.9034C8.95418 15.6109 9.42906 15.6114 9.7216 15.9047C9.80877 15.9921 9.91616 16.0566 10.0342 16.0925C10.1523 16.1284 10.2775 16.1347 10.3985 16.1107C10.5196 16.0866 10.6329 16.0331 10.7283 15.9548C10.8237 15.8765 10.8983 15.7759 10.9455 15.6618C10.9928 15.5478 11.0111 15.4239 10.9989 15.301C10.9867 15.1782 10.9444 15.0603 10.8758 14.9577C10.8071 14.8551 10.7142 14.7711 10.6052 14.7131C10.4963 14.655 10.3747 14.6248 10.2513 14.625C9.96275 14.6255 9.69951 14.4604 9.5743 14.2005C9.44909 13.9405 9.4841 13.6318 9.66435 13.4065L10.1895 12.75H9.125C8.71079 12.75 8.375 12.4142 8.375 12Z",
    fill: "#4C576C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8354 11.3292C16.0895 11.4562 16.25 11.7159 16.25 12V16.875C16.25 17.2892 15.9142 17.625 15.5 17.625C15.0858 17.625 14.75 17.2892 14.75 16.875V13.5L14.45 13.725C14.1186 13.9735 13.6485 13.9064 13.4 13.575C13.1515 13.2436 13.2186 12.7735 13.55 12.525L15.05 11.4C15.2773 11.2296 15.5813 11.2021 15.8354 11.3292Z",
    fill: "#4C576C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIcon);
export default __webpack_public_path__ + "static/media/timeline-icon.e145ced58601a83570e3f25ebcf8900d.svg";
export { ForwardRef as ReactComponent };